export default "__VITE_ASSET__aa4f8b3a__"